module.exports = __webpack_public_path__ + "static/media/new-empty-states.9e1a659d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/emptyState/new-empty-states.png
// module id = 29
// module chunks = 0